export const customerVehiclesSelector = state => state.customerVehicles;



// WEBPACK FOOTER //
// ./src/store/reducers/customerVehicles/selectors.js